import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import {
    PanelBody,Button,  __experimentalUnitControl as UnitControl, FocalPointPicker,
    __experimentalToggleGroupControl as ToggleGroupControl, 
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,
    RangeControl,SelectControl
} from '@wordpress/components';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import {MediaPlaceholder,MediaUpload } from '@wordpress/block-editor';
import {VayuBlocksDropShadow , VayuBlocksAnimation, VayuBlocksBackground, VayuBlocksDuotone, VayuBlocksAlignment,
        VayuBlocksTypography,VayuBlocksToggleControl,VayuBlocksTextControl,VayuBlocksAspectRatio} from '@vayu-blocks';


const Image = ({ attributes, setAttributes , openPanels, onTogglePanel}) => {

    const getView = VayuBlocksDevice(); 

    const [firstDesktop, setFirstDesktop] = useState(false);
    const [firstTablet, setFirstTablet] = useState(false);

    const changeImageSize = (key,value)=>{

        const updatedAttributes = {
            ...attributes?.[key],
            [getView]: value,
        };

        const isFirstRun = !attributes?.[key]?.[getView];
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        if (getView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                updatedAttributes['Tablet'] = value;
                updatedAttributes['Mobile'] = value;
                localStorage.setItem('firstTablet', 'true');
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (getView === 'Tablet') {
            if (isTabletFirstRun) {
                updatedAttributes['Mobile'] = value;
                localStorage.removeItem('firstTablet');
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            setFirstTablet(false);
            setFirstDesktop(false);
        }

       setAttributes({[key]:updatedAttributes});
    }

    const handleimageurl = (value) => {
        setAttributes({image:value.url});
        setAttributes({defaultImageWidth:value.width});
    }
    
    const handleimage = (value) => {
        setAttributes({image:value});
        setAttributes({defaultImageWidth:value.width});
    }

    // Assuming you're inside your functional component
    const options = [{ value: 'flip', label: 'Flip Block' },];

    // Conditionally add options based on the className attribute
    if (attributes.className === 'vayu_blocks_flip-box-back ') {
        options.push({ value: 'front', label: 'Front Block' });
    }

    if (attributes.className === 'vayu_blocks_flip-box-front ') {
        options.push({ value: 'back', label: 'Back Block' });
    }

    const handleImageChange = (media) => {

        if(attributes. parentBlock === 'vayu-blocks/advance-slider' && attributes.image==='http://localhost/wordpress/wp-content/plugins/vayu-blocks/public/build/block/advance-slider/../../images/no-image-long.7a9f1fa5.png'){
            setAttributes({overlayshow:false})
        }

        if (media && media.url) {
            setAttributes({ image: media.url }); // Update the image attribute with the selected image URL
        }
    };

    return (
        
            <div class="vayu_blocks_image-flip-settings_main vayu_blocks_image-settings_main">

                {/* Background Image */}
                <PanelBody 
                    title={__('Image','vayu-blocks')} 
                    opened={openPanels['slide-image']}
			        onToggle={() => onTogglePanel('slide-image')}
                >

                    {attributes.typeimage==='image' && (
                        <>

                            {(attributes.image && attributes.image !="http://localhost/wordpress/wp-content/plugins/vayu-blocks/public/build/block/advance-slider/../../images/no-image.69a0483a.png") ? (
                                <>  

                                    <div className='vayu_blocks_focal_point'>     
                                        <FocalPointPicker
                                            className='vayu_blocks_focal_point_picker'
                                            __nextHasNoMarginBottom={true}
                                            url={ attributes.image }
                                            value={ attributes.focalPoint }
                                            onDragStart={ (value)=> setAttributes({focalPoint:value})}
                                            onDrag={ (value)=> setAttributes({focalPoint:value}) }
                                            onChange={ (value)=> setAttributes({focalPoint:value}) }
                                        />

                                        <div className="vayu_blocks_replace_button_image">
                                            <MediaUpload
                                                onSelect={handleImageChange}
                                                allowedTypes={['image']}
                                                render={({ open }) => (
                                                    <Button
                                                        onClick={open} // Opens MediaUpload when clicked
                                                    >
                                                        {__('Replace', 'vayu-blocks')}
                                                    </Button>
                                                )}
                                            />
                                        </div>
                                    </div> 

                                    <VayuBlocksTextControl
                                        label={__('Alt text', 'vayu-blocks')}
                                        placeholder='Alt Text...'
                                        onChange={(value)=>setAttributes({imagealttext:value})}
                                        value={attributes.imagealttext}
                                    />

                                    <VayuBlocksAspectRatio
                                        onChange={(key,value)=>setAttributes({[key]:value})}
                                        aspectRatio = {{key:'aspectRatio', value:attributes.aspectRatio}}
                                    />

                                    <div className='vayu_block_width_height_control'>
                                        <UnitControl
                                            __next40pxDefaultSize={true}
                                            __nextHasNoMarginBottom={true}
                                            label={<VayuBlocksDeviceControl label={__('Width', 'vayu-blocks')} />}
                                            placeholder={ __( 'Auto' ) }
                                            labelPosition="top"
                                            size="__unstable-large"
                                            className="vayu_block_unit_width_control"
                                            onChange={(value)=> changeImageSize('imageWidth',value)}
                                            value={attributes.imageWidth?.[getView]}
                                            min={2}
                                            units={'px'} 
                                        />
                             
                                        <UnitControl
                                            __next40pxDefaultSize={true}
                                            __nextHasNoMarginBottom={true}
                                            label={<VayuBlocksDeviceControl label={__('Height', 'vayu-blocks')} />}
                                            placeholder={ __( 'Auto' ) }
                                            labelPosition="top"
                                            size="__unstable-large"
                                            className="vayu_block_unit_width_control"
                                            onChange={(value)=> changeImageSize('imageHeight',value)}
                                            value={attributes.imageHeight?.[getView]}
                                            min={2}
                                            units={'px'} 
                                        />

                                    </div>

                                    <ToggleGroupControl
                                        __next40pxDefaultSize={true}
                                        __nextHasNoMarginBottom={true}
                                        isBlock
                                        className="vb-image-toggle-groudp-control"
                                        isDeselectable={true}
                                        label={ __( 'Object Fit', 'vayu-blocks' ) }
                                        value={ attributes.imagebackgroundSize }
                                        onChange={(value)=> setAttributes({imagebackgroundSize:value})}
                                        >
                                        <ToggleGroupControlOption
                                            label="Cover"
                                            value="cover"
                                        />
                                        <ToggleGroupControlOption
                                            label="Contain"
                                            value="contain"
                                        />
                                    </ToggleGroupControl>

                                    <br/>

                                    <VayuBlocksAlignment
                                        onChange={(key,value)=>setAttributes({[key]:value})}
                                        alignment = {{key:'imagealignment',value:attributes.imagealignment}}
                                    />

                                    <br/>
                                    <VayuBlocksDuotone
                                        duotoneValue={attributes.duotone}
                                        setAttributes={setAttributes}
                                        key={'duotone'}
                                    />

                                    <VayuBlocksDropShadow 
                                        onChange={(key,value)=>setAttributes({[key]:value})}
                                        dropShadow={{key:'imageboxShadow',value:attributes.imageboxShadow}}
                                    />

                                </>
                                ) : (
                                    <>
                                    <MediaPlaceholder
                                        icon="format-image"
                                        labels={{
                                            title: __('Background Image', 'vayu-blocks'),
                                            name: __('an image', 'vayu-blocks')
                                        }}
                                        onSelect={(media) => {
                                            handleimageurl(media)
                                        }} 
                                        onSelectURL={(value) => handleimage(value)}                                                            
                                        accept="image/*"
                                        allowedTypes={['image']}
                                    />
                                    <br/>
                                    </>
                                )}
                        </>
                    )}
   
                </PanelBody >
                
                {/* Overlay and animation effect  */}
                <PanelBody 
                    title={__('Advance Effect','vayu-blocks')}  
                    opened={openPanels['slide-effect']}
			        onToggle={() => onTogglePanel('slide-effect')}>

                    <VayuBlocksAnimation
                        animationData={attributes.animationData}
                        onChange={(key, value) => {setAttributes({ [key]: value });}}
                        dataKey="animationData"
                    />

                </PanelBody>

                <PanelBody 
                    title={__('Parallax Effect','vayu-blocks')}  
                    opened={openPanels['parallex-effect']}
			        onToggle={() => onTogglePanel('parallex-effect')}
                >

                        <VayuBlocksToggleControl
                            label={__('Parallax', 'vayu-blocks')}
                            help={__('Creates a smooth scroll-based motion effect on the image.', 'vayu-blocks')}
                            checked={attributes.parallax?.switch}
                            onChange={(value) =>
                                setAttributes({
                                    parallax: {
                                        ...attributes.parallax,
                                        switch: value,
                                    },
                                })
                            }
                        />

                        {attributes.parallax?.switch && (
                            <>

                               <SelectControl
                                    label={__('Orientation', 'vayu-blocks')}
                                    value={attributes.parallax?.orientation ?? 'up'}
                                    options={[
                                        { label: __('Up', 'vayu-blocks'), value: 'up' },
                                        { label: __('Down', 'vayu-blocks'), value: 'down' },
                                        { label: __('Left', 'vayu-blocks'), value: 'left' },
                                        { label: __('Right', 'vayu-blocks'), value: 'right' },
                                        { label: __('Up Left', 'vayu-blocks'), value: 'up-left' },
                                        { label: __('Up Right', 'vayu-blocks'), value: 'up-right' },
                                        { label: __('Down Left', 'vayu-blocks'), value: 'down-left' },
                                        { label: __('Down Right', 'vayu-blocks'), value: 'down-right' },
                                    ]}
                                    onChange={(value) =>
                                        setAttributes({
                                            parallax: {
                                                ...attributes.parallax,
                                                orientation: value,
                                            },
                                        })
                                    }
                                />

                                <SelectControl
                                    label={__('Transition', 'vayu-blocks')}
                                    value={attributes.parallax?.transition ?? 'cubic-bezier(0,0,0,1)'}
                                    options={[
                                        { label: 'Ease', value: 'ease' },
                                        { label: 'Linear', value: 'linear' },
                                        { label: 'Ease In', value: 'ease-in' },
                                        { label: 'Ease Out', value: 'ease-out' },
                                        { label: 'Ease In Out', value: 'ease-in-out' },
                                        { label: 'Cubic Bezier (Fast)', value: 'cubic-bezier(0.5, 0, 0.5, 1)' },
                                        { label: 'Cubic Bezier (Sharp)', value: 'cubic-bezier(0.33, 1, 0.68, 1)' },
                                        { label: 'Cubic Bezier (Bounce)', value: 'cubic-bezier(0.77, 0, 0.175, 1)' },
                                        { label: 'Cubic Bezier (Snappy)', value: 'cubic-bezier(0.4, 0, 0.2, 1)' },
                                        { label: 'Cubic Bezier (Slow)', value: 'cubic-bezier(0,0,0,1)' },
                                    ]}
                                    onChange={(value) =>
                                        setAttributes({
                                            parallax: {
                                                ...attributes.parallax,
                                                transition: value,
                                            },
                                        })
                                    }
                                />

                                <RangeControl
                                    __next40pxDefaultSize={true}
                                    __nextHasNoMarginBottom={true}
                                    label={__('Scale', 'vayu-blocks')}
                                    min={1}
                                    max={5}
                                    step={0.1}
                                    value={attributes.parallax?.scale ?? 1.3}
                                    onChange={(value) =>
                                        setAttributes({
                                            parallax: {
                                                ...attributes.parallax,
                                                scale: value,
                                            },
                                        })
                                    }
                                />

                                <RangeControl
                                    __next40pxDefaultSize={true}
                                    __nextHasNoMarginBottom={true}
                                    label={__('Delay', 'vayu-blocks')}
                                    min={0}
                                    max={3}
                                    step={0.1}
                                    value={attributes.parallax?.delay ?? 0.2}
                                    onChange={(value) =>
                                        setAttributes({
                                            parallax: {
                                                ...attributes.parallax,
                                                delay: value,
                                            },
                                        })
                                    }
                                />

                               <RangeControl
                                    label={__('Max Transition (%)', 'vayu-blocks')}
                                    help={__('Limits how far the image moves during scroll. Recommended between 1–99%.', 'vayu-blocks')}
                                    min={1}
                                    max={99}
                                    step={1}
                                    value={attributes.parallax?.maxTransition ?? 60}
                                    onChange={(value) =>
                                        setAttributes({
                                            parallax: {
                                                ...attributes.parallax,
                                                maxTransition: value,
                                            },
                                        })
                                    }
                                />

                                <VayuBlocksToggleControl
                                    label={__('Overflow', 'vayu-blocks')}
                                    help={__('Allow image to translate outside its bounds. May overlap other content.', 'vayu-blocks')}
                                    checked={attributes.parallax?.overflow ?? true}
                                    onChange={(value) =>
                                        setAttributes({
                                            parallax: {
                                                ...attributes.parallax,
                                                overflow: value,
                                            },
                                        })
                                    }
                                />
                            </>
                        )}

                </PanelBody>

                <PanelBody 
                    title={__('Caption','vayu-blocks')} 
                    opened={openPanels['slide-caption']}
			        onToggle={() => onTogglePanel('slide-caption')}>

                    <VayuBlocksToggleControl
                        label={__('Caption', 'vayu-blocks')}
                        checked={attributes.caption}
                        onChange={(value) => setAttributes({ caption: value })}
                    />

                    {attributes.caption &&(
                        <>

                            <VayuBlocksTextControl
                                label={__('Text', 'vayu-blocks')}
                                placeholder='Caption Text...'
                                onChange={(value)=>setAttributes({captiontext:value})}
                                value={attributes.captiontext}
                            />

                            <VayuBlocksAlignment
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                alignment = {{key:'captionalignment',value:attributes.captionalignment}}
                            />
                            
                            <VayuBlocksBackground
                                 onChange={(key,value)=>setAttributes({[key]:value})}
                                colorPanel = {[
                                    {
                                        active: ['color'],
                                        label: 'Text',
                                        key:'captioncolor',
                                        value:attributes.captioncolor
            
                                    }
                                ]}
                            />

                            <VayuBlocksTypography
                                value={attributes.typography}
                                onChange={(newValues) => {setAttributes({typography:newValues})}}
                            />

                        </>
                    )}
                </PanelBody>

            </div>

    );
};

export default Image;